<template>
  <modal-form-helper :data="{...mdldata, title: form.name, isModal: asModal}" :form="post">
    <template #title>
      <div>
        <div v-if="form.show_title">
          <div v-if="form_type == 'data'">
            <p class="ms-3 text-gray-800 dm-fs-1-1-rem fw-bolder py-2">{{ form.name }}</p>
          </div>
          <div v-else>
            <!--hide title on create Forms if embedded-->
            <div v-if="asModal">{{form.name}}</div>
          </div>
        </div>
      </div>
    </template>
    <template #body>
      <div>
        <div
            id="company.generic_errors"
            v-if="post.errors.has('company.generic_errors')"
            role="alert"
            class="alert alert-secondary"
        >
          <has-error :form="post" field="company.generic_errors"></has-error>
        </div>
        <div
            id="contact.generic_errors"
            v-if="post.errors.has('contact.generic_errors')"
            role="alert"
            class="alert alert-secondary"
        >
          <has-error :form="post" field="contact.generic_errors"></has-error>
        </div>
        <div
            id="contact.generic_errors"
            v-if="post.errors.has('address.generic_errors')"
            role="alert"
            class="alert alert-secondary"
        >
          <has-error :form="post" field="address.generic_errors"></has-error>
        </div>
        <div
            id="opportunity.generic_errors"
            v-if="post.errors.has('opportunity.generic_errors')"
            role="alert"
            class="alert alert-secondary"
        >
          <has-error :form="post" field="opportunity.generic_errors"></has-error>
        </div>
      </div>

      <div ref="field_defs" class="d-none">
        <!--company-->
        <div ref="field_company_name">
          <!--<form-input :required="false"-->
          <!--            v-model="post.company.name" :form="post"-->
          <!--            name="company.name"-->
          <!--            label="Company"-->
          <!--            @input="searchNameDebounced"-->
          <!--            :debounce="true"-->
          <!--            :debounce-settings="{-->
          <!--              url: genUrl('companies', null, 'search'),-->
          <!--              route_name: 'company_details',-->
          <!--              param: 'name',-->
          <!--              label: 'name'}"-->
          <!--/>-->
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Company Name</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  :editable="$hasPermission('Company', 'edit-overview')"
                  :update="companyBaseUpdate"
                  name="name"
                  :value="dataRecord.company.name"
                  :context="dataRecord.company">
                <template #label>{{ dataRecord.company.name }}</template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <label for="company.name" class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label">Company Name</label>
            <div :class="cnameBaseClasses">
              <autocomplete
                  :key="lockKeycname"
                  ref="cNameAutoComplete"
                  :default-value="post.company.name"
                  :search="searchName"
                  placeholder="Type or select one"
                  aria-label="Company Name"
                  :get-result-value="getResultValue"
                  @submit="cnameHandleSubmit"
                  :submitOnEnter="true"
                  :debounce-time="500"
              ></autocomplete>
              <has-error :form="post" field="company.name"></has-error>
            </div>
          </div>

          <!--<div class="">-->
          <!--  <input type="text"-->
          <!--         v-model="post.company.name"-->
          <!--         @keyup="searchCnameDebounced"-->
          <!--         id="cname_search_input"-->
          <!--         class="form-control cname_search_input"-->
          <!--         placeholder="Search or type a name"-->
          <!--         data-kt-menu-trigger="click"-->
          <!--         data-kt-menu-attach="parent"-->
          <!--         data-kt-menu-placement="bottom-start"/>-->
          <!--  <div class="menu menu-sub menu-sub-dropdown menu-rounded menu-gray-800 menu-state-bg-light-primary cname_result_list_menu"-->
          <!--       data-kt-menu="true"-->
          <!--       id="cname_result_list_menu">-->
          <!--    <div v-show="cnameLoading" class="svg-icon svg-icon-1 text-center my-2">-->
          <!--      <i class="fa fa-2x fa-circle-notch fa-pulse text-primary"></i>-->
          <!--    </div>-->
          <!--    <div v-for="cname in cnameResults" class="menu-item px-3">-->
          <!--        <div class="menu-link px-3">-->
          <!--            <span class="menu-title">{{ cname.name }}</span>-->
          <!--        </div>-->
          <!--    </div>-->
          <!--  </div>-->
          <!--</div>-->
        </div>
        <div ref="field_employees">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Employees</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  :update="companyDetailUpdate"
                  name="employees"
                  :value="dataRecord.company.detail.employees"
                  :context="dataRecord.company">
                <template #label>{{ dataRecord.company.detail.employees }}</template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-input :required="false"
                        :disabled="companyLocked"
                        v-model="post.company_detail.employees" :form="post"
                        name="company_detail.employees" label="Employees"/>
          </div>
        </div>
        <div ref="field_company_type">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Company Type</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  type="select"
                  :update="companyDetailUpdate"
                  name="company_type"
                  :context="dataRecord.company"
                  :options="drdata.company_types"
                  :config="{label: 'title'}"
                  :value="$_.get(dataRecord.company.detail, 'company_type')"
                  :label="$_.findGet(drdata.company_types, cs => cs.id==dataRecord.company.detail.company_type, 'title')">
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-select2
                :disabled="companyLocked"
                :required="false"
                name="company_detail.company_type"
                label="Company Type"
                :form="post"
                v-model="post.company_detail.company_type"
                :options="drdata.company_types"
                :config="{
                  label: 'title',
                }"
                :classes="['form-select-solid']"
            />
          </div>
        </div>
        <div ref="field_company_house_no">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Companies House</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  :update="companyDetailUpdate"
                  name="employees"
                  :value="dataRecord.company.detail.company_house_no"
                  :context="dataRecord.company">
                <template #label>{{ dataRecord.company.detail.company_house_no }}</template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
          <form-input
              :disabled="companyLocked"
              :required="false"
              v-model="post.company_detail.company_house_no"
              :form="post"
              name="company_detail.company_house_no"
              label="Companies House"
            />
          </div>
        </div>

        <!--company_detail-->
        <div ref="field_sectors">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Sectors</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  type="select"
                  :update="companyDetailUpdate"
                  name="sectors"
                  :context="dataRecord.company"
                  :options="drdata.sectors"
                  :config="{label: 'title', multiple: true}"
                  :value="$_.get(dataRecord.company.detail, 'sectors', [])">
                <template #label>
                  <span class="fw-normal dm-fs-0-9-rem d-flex flex-wrap gap-1 justify-content-end">
                    <span v-for="cs in $_.get(dataRecord.company.detail, 'sectors', [])" class="ms-1 badge badge-light-primary">
                      {{ $_.findGet(drdata.sectors, jt => jt.id==cs, 'title') }}
                    </span>
                  </span>
                </template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-select2
                :disabled="companyLocked"
                :required="false"
                name="details.sectors"
                label="Sector"
                :form="post"
                v-model="post.company_detail.sectors"
                :options="drdata.sectors"
                :config="{
                  label: 'title',
                  multiple: true,
                }"
                :classes="['form-select-solid']"
            />
          </div>
        </div>
        <div ref="field_sub_sectors">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Sub Sectors</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  type="select"
                  :update="companyDetailUpdate"
                  name="sub_sectors"
                  :context="dataRecord.company"
                  :options="optgroupSubsectors"
                  :config="{label: 'title', multiple: true, preventTransform: true}"
                  :value="$_.get(dataRecord.company.detail, 'sub_sectors', [])">
                <template #label>
                  <span class="fw-normal dm-fs-0-9-rem d-flex flex-wrap gap-1 justify-content-end">
                    <span v-for="cs in $_.get(dataRecord.company.detail, 'sub_sectors', [])" class="ms-1 badge badge-light-primary">
                      {{ $_.findGet(drdata.sub_sectors, jt => jt.id==cs, 'title') }}
                    </span>
                  </span>
                </template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-select2
                :disabled="companyLocked"
                :required="false"
                name="details.sub_sectors"
                label="Sub Sector"
                :form="post"
                v-model="post.company_detail.sub_sectors"
                :options="optgroupSubsectors"
                :config="{
                  multiple: true,
                  preventTransform: true,
                }"
                :classes="['form-select-solid']"
            />
          </div>
        </div>
        <div ref="field_source">
          <form-select2
              :disabled="companyLocked"
              :required="false"
              name="company_detail.source"
              label="Source"
              :form="post"
              v-model="post.company_detail.source"
              :options="drdata.sources"
              :config="{
                id: 'id',
                label: 'title',
                ajax: {
                  paginated: false,
                  url: genUrl('source_type', null,  'get'),
                  term: 'title',
                }
              }"
              :classes="['form-select-solid']"
          />
        </div>
<!--        <div ref="field_ownership">-->
<!--          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">-->
<!--            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Ownership</label></div>-->
<!--            <div :class="DATA_INPUT_VALUE_COL_CLASSES">-->
<!--              <editable-input-->
<!--                  type="select"-->
<!--                  :update="companyBaseUpdate"-->
<!--                  name="ownership"-->
<!--                  :context="dataRecord.company"-->
<!--                  :options="drdata.ownerships"-->
<!--                  :config="{label: 'name'}"-->
<!--                  :value="$_.get(dataRecord.company, 'ownership')"-->
<!--                  :label="$_.findGet(drdata.ownerships, cs => cs.id==dataRecord.company.ownership, 'name')">-->
<!--              </editable-input>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div v-else-if="form_type == 'create'">-->
<!--            <form-select2-->
<!--                :disabled="companyLocked"-->
<!--                :required="false"-->
<!--                name="company.ownership"-->
<!--                label="Ownership"-->
<!--                :form="post"-->
<!--                v-model="post.company.ownership"-->
<!--                :options="drdata.ownerships"-->
<!--                :config="{-->
<!--                  label: 'name',-->
<!--                }"-->
<!--                :classes="['form-select-solid']"-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
        <div ref="field_revenue">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Revenue</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  :update="companyBaseUpdate"
                  name="revenue"
                  :value="dataRecord.company.revenue"
                  :context="dataRecord.company">
                <template #label>{{ dataRecord.company.revenue }}</template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-input :required="false"
                        :disabled="companyLocked"
                        v-model="post.company.revenue" :form="post"
                        name="company.revenue" label="Revenue"/>
          </div>
        </div>
        <div ref="field_ebitda">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>EBITDA</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  :update="companyBaseUpdate"
                  name="ebitda"
                  :value="dataRecord.company.ebitda"
                  :context="dataRecord.company">
                <template #label>{{ dataRecord.company.ebitda }}</template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-input :required="false"
                        :disabled="companyLocked"
                        v-model="post.company.ebitda" :form="post"
                        name="company.ebitda" label="EBITDA"/>
          </div>
        </div>
        <div ref="field_linkedin_url">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Linkedin URL</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  :update="companyBaseUpdate"
                  name="linkedin_url"
                  :value="dataRecord.company.linkedin_url"
                  :context="dataRecord.company">
                <template #label>{{ dataRecord.company.linkedin_url }}</template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-input :required="false"
                        :disabled="companyLocked"
                        v-model="post.company.linkedin_url" :form="post"
                        name="company.linkedin_url" label="Linkedin URL"/>
          </div>
        </div>
        <div ref="field_website">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Website</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  :update="companyDetailUpdate"
                  name="website"
                  :value="dataRecord.company.detail.website"
                  :context="dataRecord.company">
                <template #label>{{ dataRecord.company.detail.website }}</template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-input :required="false"
                        :disabled="companyLocked"
                        v-model="post.company_detail.website" :form="post"
                        name="company_detail.website" label="Website"/>
          </div>
        </div>
        <div ref="field_main_shareholders">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Main Shareholders</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  :update="companyDetailUpdate"
                  name="main_shareholders"
                  :value="dataRecord.company.detail.main_shareholders"
                  :context="dataRecord.company">
                <template #label>{{ dataRecord.company.detail.main_shareholders }}</template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-input :required="false"
                        :disabled="companyLocked"
                        v-model="post.company_detail.main_shareholders" :form="post"
                        name="company_detail.main_shareholders" label="Main Shareholders"/>
          </div>
        </div>
        <div ref="field_min_investment_size">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Min Investment Size</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  :update="companyDetailUpdate"
                  name="min_investment_size"
                  :value="dataRecord.company.detail.min_investment_size"
                  :context="dataRecord.company">
                <template #label>{{ dataRecord.company.detail.min_investment_size }}</template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-input :required="false"
                        :disabled="companyLocked"
                        v-model="post.company_detail.min_investment_size" :form="post"
                        name="company_detail.min_investment_size" label="Min Investment Size"/>
          </div>
        </div>
        <div ref="field_max_investment_size">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Max Investment Size</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  :update="companyDetailUpdate"
                  name="max_investment_size"
                  :value="dataRecord.company.detail.max_investment_size"
                  :context="dataRecord.company">
                <template #label>{{ dataRecord.company.detail.max_investment_size }}</template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-input :required="false"
                        :disabled="companyLocked"
                        v-model="post.company_detail.max_investment_size" :form="post"
                        name="company_detail.max_investment_size" label="Max Investment Size"/>
          </div>
        </div>
        <div ref="field_current_fund_size">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Current Fund Size</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  :update="companyDetailUpdate"
                  name="current_fund_size"
                  :value="dataRecord.company.detail.current_fund_size"
                  :context="dataRecord.company">
                <template #label>{{ dataRecord.company.detail.current_fund_size }}</template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-input :required="false"
                        :disabled="companyLocked"
                        v-model="post.company_detail.current_fund_size" :form="post"
                        name="company_detail.current_fund_size" label="Current Fund Size"/>
          </div>
        </div>
        <div ref="field_left_to_deploy">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Left To Deploy</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  :update="companyDetailUpdate"
                  name="left_to_deploy"
                  :value="dataRecord.company.detail.left_to_deploy"
                  :context="dataRecord.company">
                <template #label>{{ dataRecord.company.detail.left_to_deploy }}</template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-input :required="false"
                        :disabled="companyLocked"
                        v-model="post.company_detail.left_to_deploy" :form="post"
                        name="company_detail.left_to_deploy" label="Left To Deploy"/>
          </div>
        </div>
        <div ref="field_country">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Country</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  :editable="$hasPermission('Company', 'edit-overview')"
                  type="select"
                  :update="companyBaseUpdate"
                  name="country"
                  :context="dataRecord.company"
                  :options="drdata.country_codes"
                  :config="{id: 'code', label: 'name'}"
                  :value="$_.get(dataRecord.company, 'country')"
                  :label="$_.findGet(drdata.country_codes, cs => cs.code==dataRecord.company.country, 'name')">
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-select2
                :disabled="companyLocked"
                :required="false"
                name="company.country"
                label="Country"
                :form="post"
                v-model="post.company.country"
                :options="drdata.country_codes"
                :config="{
                  id: 'code',
                  label: 'name',
                }"
                :classes="['form-select-solid']"
            />
          </div>
        </div>
        <div ref="field_business_description">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Business Description</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              NOT_APPLICABLE
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-input :required="false"
                        type="textarea"
                      :disabled="companyLocked"
                      v-model="post.company.business_description" :form="post"
                      name="company.business_description" label="Business Description"/>
          </div>
        </div>
        <div ref="field_acquisition_strategy">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Acquisition Strategy</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              NOT_APPLICABLE
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-input :required="false"
                        type="textarea"
                      :disabled="companyLocked"
                      v-model="post.company.acquisition_strategy" :form="post"
                      name="company.acquisition_strategy" label="Acquisition Strategy"/>
          </div>
        </div>
        <div ref="field_pe_companies">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>PE/VC</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  type="select"
                  :update="companyBaseUpdate"
                  name="pe_companies"
                  :value="$_.map(dataRecord.company.pe_companies, ({id}) => id)"
                  :context="dataRecord.company"
                  :options="pe_companies"
                  :config="pe_company_ajax_config">
                <template #label>
                  <span class="fw-normal dm-fs-0-9-rem d-flex flex-wrap gap-1 justify-content-end">
                    <span v-for="cs in $_.get(dataRecord.company, 'pe_companies', [])" class="ms-1 badge badge-light-primary">
                      {{ cs.name }}
                    </span>
                  </span>
                </template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-select2
                :disabled="companyLocked"
                :required="false"
                name="company.pe_companies"
                label="PE/VC"
                :form="post"
                v-model="post.company.pe_companies"
                :options="pe_companies"
                :config="pe_company_ajax_config"
                :classes="['form-select-solid']"
            />
          </div>
        </div>

        <div ref="field_company_followers">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Followers</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  type="select"
                  :update="companyBaseUpdate"
                  name="followers"
                  :value="$_.map(dataRecord.company.followers, ({identifier}) => identifier)"
                  :context="dataRecord.company"
                  :options="followers_company"
                  :config="search_conf_team_user">
                <template #label>
                  <span class="fw-normal dm-fs-0-9-rem d-flex flex-wrap gap-1 justify-content-end">
                    <span v-for="cs in $_.get(dataRecord.company, 'followers', [])" class="ms-1 badge badge-light-primary">
                      {{ cs.name }}
                    </span>
                  </span>
                </template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-select2
                :disabled="companyLocked"
                :required="false"
                name="company.followers"
                label="Followers"
                :form="post"
                v-model="post.company.followers"
                :options="followers_company"
                :config="search_conf_team_user"
                :classes="['form-select-solid']"
            />
          </div>
        </div>

        <div ref="field_company_created_by_entry">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Created By</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input :update="companyBaseUpdate" name="created_by_entry"
                vert-position="top"
                placement="top"
                type="user_select"
                :context="dataRecord.company"
                :options="dataRecord.company.created_by_entry ? dataRecord.company.created_by_entry : []"
                :config="{id: 'id', label: 'name'}"
                :value="$_.get(dataRecord.company.created_by_entry, 'id')"
                label="Created By"
                  >
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-select2
                name="company.created_by_entry"
                label="Created By"
                :required="false"
                :form="post"
                :template="userTemplate"
                :selection-template="userSelectionTemplate"
                v-model="post.company.created_by_entry"
                :options="users"
                :config="{
                      id: 'id',
                      label: 'name',
                      multiple: true,
                      ajax: {
                        paginated: true,
                        url: genUrl('users', null,  'search'),
                        term: 'query',
                      }
                    }"
                :classes="['form-select-solid form-select-sm']"
            >
            </form-select2>
          </div>
        </div>

        <!--address-->
        <div ref="field_branch">
          <!--<form-input :required="false"-->
          <!--            v-model="post.address.branch" :form="post"-->
          <!--            name="address.branch" label="Branch"/>-->
          <label for="address.branch" class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label">Branch</label>
          <div :class="branchBaseClasses">
            <autocomplete
                :key="lockKeybname"
                ref="branchAutoComplete"
                :default-value="post.address.branch"
                :search="searchBname"
                placeholder="Type or select one"
                aria-label="Branch"
                :get-result-value="getBnameResultValue"
                @submit="branchHandleSubmit"
                :submitOnEnter="true"
                :debounce-time="500"
            ></autocomplete>
            <has-error :form="post" field="address.branch"></has-error>
          </div>
        </div>
        <div ref="field_street_line_one">
          <form-input :required="false"
                      :disabled="addressLocked"
                      v-model="post.address.street_line_one" :form="post"
                      name="address.street_line_one" label="Address - Street 1"/>
        </div>
        <div ref="field_street_line_two">
          <form-input :required="false"
                      :disabled="addressLocked"
                      v-model="post.address.street_line_two" :form="post"
                      name="address.street_line_two" label="Address - Street 2"/>
        </div>
        <div ref="field_city">
          <form-input :required="false"
                      :disabled="addressLocked"
                      v-model="post.address.city" :form="post"
                      name="address.city" label="City"/>
        </div>
        <div ref="field_state">
          <form-input :required="false"
                      :disabled="addressLocked"
                      v-model="post.address.state" :form="post"
                      name="address.state" label="State"/>
        </div>
        <div ref="field_postcode">
          <form-input :required="false"
                      :disabled="addressLocked"
                      v-model="post.address.postcode" :form="post"
                      name="address.postcode" label="Postcode"/>
        </div>

        <!--contact-->
        <div ref="field_title">
          <form-select2
              :required="false"
              name="title"
              label="Title"
              :form="post"
              v-model="post.contact.title"
              :options="drdata.titles"
              :config="{
                          id: 'id',
                          label: 'title',
                          ajax: {
                            paginated: false,
                            url: genUrl('user_title', null,  'get'),
                            term: 'title',
                          }
                        }"
              :classes="['form-select-solid']"
          />
        </div>
        <div ref="field_first_name">
          <!--<form-input :required="false"-->
          <!--            v-model="post.contact.first_name" :form="post"-->
          <!--            name="contact.first_name" label="First Name"/>-->
          <label for="contact.first_name" class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label">First Name</label>
          <div :class="fnameBaseClasses">
            <autocomplete
                :key="lockKeyfname"
                ref="fNameAutoComplete"
                :default-value="post.contact.first_name"
                :search="searchFname"
                placeholder="Type or select one"
                aria-label="First Name"
                :get-result-value="getFnameResultValue"
                @submit="fnameHandleSubmit"
                :submitOnEnter="true"
                :debounce-time="500"
            ></autocomplete>
            <has-error :form="post" field="contact.first_name"></has-error>
          </div>
        </div>
        <div ref="field_last_name">
          <form-input :required="false"
                      :disabled="contactLocked"
                      v-model="post.contact.last_name" :form="post"
                      name="contact.last_name" label="Last Name"/>
        </div>
        <div ref="field_contact_office">
          <form-select2
                  :disabled="contactLocked"
                  name="contact.office"
                  label="Office"
                  :form="post"
                  v-model="post.contact.office"
                  :options="contact_offices"
                  :config="contact_office_ajax_config"
                  :classes="['form-select-solid']"
              />
        </div>
        <div ref="field_contact_tracker">
          <form-check :disabled="contactLocked" v-model="post.contact.tracker" :required="false" :form="post" name="contact.tracker" label="Track Job Change"/>
        </div>
        <div ref="field_contact_linkedin_url">
          <form-input :disabled="contactLocked" v-model="post.contact.linkedin_url" :required="false" :form="post" name="contact.linkedin_url" label="Linkedin Url"/>
        </div>
        <div ref="field_direct_mobile">
          <form-input :disabled="contactLocked" v-model="post.contact.direct_mobile" :required="false" :form="post" name="contact.direct_mobile" label="Mobile Phone"/>
        </div>
        <div ref="field_direct_phone">
          <form-input :disabled="contactLocked" v-model="post.contact.direct_phone" :required="false" :form="post" name="contact.direct_phone" label="Office Phone"/>
        </div>
        <div ref="field_email">
          <form-input :disabled="contactLocked" v-model="post.contact.email" :required="false" :form="post" name="contact.email" label="Email"/>
        </div>
        <div ref="field_job_title">
          <form-input :disabled="contactLocked" v-model="post.contact.job_title" :required="false" :form="post" name="contact.job_title" label="Job title"/>
        </div>
        <div ref="field_users">
          <form-select2
              :disabled="contactLocked"
              :required="false"
              name="contact.users"
              label="Relationships"
              placeholder=""
              :form="post"
              :template="userTemplate"
              :selection-template="userSelectionTemplate"
              v-model="post.contact.users"
              :options="users"
              :config="{
                    id: 'id',
                    label: 'name',
                    multiple: true,
                    ajax: {
                      paginated: true,
                      url: genUrl('users', null,  'search'),
                      term: 'query',
                    }
                  }"
              :classes="['form-select-solid']"
          >
          </form-select2>
        </div>
        <div ref="field_tags">
          <form-select2
              :disabled="contactLocked"
              :required="false"
              name="contact.tags"
              label="Tags"
              :form="post"
              v-model="post.contact.tags"
              @change="checkAuthorizedUser"
              :options="tags"
              :config="search_conf_tags"
              :classes="['form-select-solid']"
          >
          </form-select2>
        </div>

        <!--project-->

        <div ref="field_project_name">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Project Name</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  :update="projectUpdate"
                  name="name"
                  :value="dataRecord.project.name"
                  :context="dataRecord.project">
                <template #label>{{ dataRecord.project.name }}</template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-input
              v-model="post.project.name"
              :form="post"
              name="project.name"
              label="Project Name"
              :debounce="true"
              :debounce-settings="{
                url: genUrl('projects', null, 'search'),
                route_name: 'project_details',
                param: 'name',
                label: 'name'
              }"/>
          </div>
        </div>

        <div ref="field_project_type">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Project Type</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <span class="bg-transparent me-auto">
                {{
                  $_.get($_.first($_.filter(drdata.transaction_types, (ps) => (ps.id == dataRecord.project.project_type))), 'title')
                }}
              </span>
              <!--<editable-input-->
              <!--    placement="top"-->
              <!--    type="select"-->
              <!--    :update="projectUpdate"-->
              <!--    name="project_type"-->
              <!--    :value="dataRecord.project.project_type"-->
              <!--    :context="dataRecord.project"-->
              <!--    :options="drdata.transaction_types"-->
              <!--    :config="{id: 'id', label: 'title', clearable: false, searchable: false}">-->
              <!--  <template #label>-->
              <!--    <span class="bg-transparent me-auto">-->
              <!--      {{-->
              <!--        $_.get($_.first($_.filter(drdata.transaction_types, (ps) => (ps.id == dataRecord.project.project_type))), 'title')-->
              <!--      }}-->
              <!--    </span>-->
              <!--  </template>-->
              <!--</editable-input>-->
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-select2
                name="project.project_type"
                label="Project Type"
                :form="post"
                @change="onTrxChange(post.project.project_type)"
                v-model="post.project.project_type"
                :options="drdata.transaction_types"
                :config="{
                      label: 'title',
                      searchable: false,
                      clearable: false,
                    }"
                :classes="['form-select-solid form-select-sm']"
            />
          </div>
        </div>

        <div ref="field_project_stage">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Project Stage</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  placement="top"
                  type="select"
                  :update="projectUpdate"
                  name="project_stage"
                  :options="$_.filter(project_stages, (ps) => (ps.transaction_type == dataRecord.project.project_type))"
                  :config="{id: 'id', label: 'name', clearable: false, searchable: false}"
                  :value="dataRecord.project.project_stage"
                  :context="dataRecord.project">
                <template #label>{{
                              $_.get($_.first($_.filter(project_stages, (ps) => (ps.id == dataRecord.project.project_stage))), 'name')
                            }}
                </template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-select2
                :disabled="!post.project.project_type"
                name="project.project_stage"
                label="Project Stage"
                :form="post"
                v-model="post.project.project_stage"
                :options="project_stages"
                :config="{
                      id: 'id',
                      label: 'name',
                      searchable: false,
                      clearable: false,
                    }"
                :classes="['form-select-solid form-select-sm']"
            />
          </div>
        </div>

        <div ref="field_working_for">
          <div>
            <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
              <div :class="DATA_INPUT_LABEL_CLASSES"><label>Company Working For</label></div>
              <div :class="DATA_INPUT_VALUE_COL_CLASSES">
                <editable-input
                    :editable="isBuyside"
                    placement="top"
                    type="select"
                    :update="projectUpdate"
                    name="working_for"
                    :value="dataRecord.project.working_for"
                    :context="dataRecord.project"
                    :options="companies_wf"
                    :config="{
                          id: 'id',
                          label: 'name',
                          ajax: {
                            paginated: false,
                            url: genUrl('companies', null,  'search'),
                            term: 'name',
                          }
                        }">
                  <template #label>
                    <span class="bg-transparent me-auto">
                      {{ $_.get(dataRecord.project.working_for, 'name') }}
                    </span>
                  </template>
                </editable-input>
              </div>
            </div>
            <div v-else-if="form_type == 'create'">
              <form-select2
                  :disabled="!isBuyside"
                  name="project.working_for"
                  label="Company Working For"
                  :form="post"
                  v-model="post.project.working_for"
                  :options="companies_wf"
                  :config="{
                        id: 'id',
                        label: 'name',
                        ajax: {
                          paginated: false,
                          url: genUrl('companies', null,  'search'),
                          term: 'name',
                        }
                      }"
                  :classes="['form-select-solid form-select-sm']"
              >
              </form-select2>
            </div>
          </div>
        </div>

        <div ref="field_introducers">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Introducers</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input :update="projectUpdate" name="introducers"
                vert-position="top"
                placement="top"
                type="user_select"
                :context="dataRecord.project"
                :options="dataRecord.project.introducers"
                :config="{id: 'id', label: 'name', multiple: true}"
                :value="$_.map(dataRecord.project.introducers, ({id}) => id)"
                label="Introducers"
                  >
                <template #label>
                  <span class="fw-normal dm-fs-0-9-rem d-flex flex-wrap gap-1 justify-content-end">
                    <span v-for="cs in $_.get(dataRecord.project, 'introducers', [])" class="ms-1 badge badge-light-primary">
                      {{ cs.name }}
                    </span>
                  </span>
                </template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-select2
                name="project.introducers"
                label="Introducers"
                :required="false"
                :form="post"
                :template="userTemplate"
                :selection-template="userSelectionTemplate"
                v-model="post.project.introducers"
                :options="introducers"
                :config="{
                      id: 'id',
                      label: 'name',
                      multiple: true,
                      ajax: {
                        paginated: true,
                        url: genUrl('users', null,  'search'),
                        term: 'query',
                      }
                    }"
                :classes="['form-select-solid form-select-sm']"
            >
            </form-select2>
          </div>
        </div>

        <div ref="field_project_team_members">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Team Members</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input :update="projectUpdate" name="team_members"
                vert-position="top"
                placement="top"
                type="user_select"
                :context="dataRecord.project"
                :options="dataRecord.project.team_members"
                :config="{id: 'id', label: 'name', multiple: true}"
                :value="$_.map(dataRecord.project.team_members, ({id}) => id)"
                label="Team Members"
                  >
                <template #label>
                  <span class="fw-normal dm-fs-0-9-rem d-flex flex-wrap gap-1 justify-content-end">
                    <span v-for="cs in $_.get(dataRecord.project, 'team_members', [])" class="ms-1 badge badge-light-primary">
                      {{ cs.name }}
                    </span>
                  </span>
                </template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-select2
                name="project.team_members"
                label="Team members"
                :required="false"
                :form="post"
                :template="userTemplate"
                :selection-template="userSelectionTemplate"
                v-model="post.project.team_members"
                :options="pteam_members"
                :config="{
                      id: 'id',
                      label: 'name',
                      multiple: true,
                      ajax: {
                        paginated: true,
                        url: genUrl('users', null,  'search'),
                        term: 'query',
                      }
                    }"
                :classes="['form-select-solid form-select-sm']"
            >
            </form-select2>
          </div>
        </div>

        <div ref="field_buyer_categories">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Buyer Categories</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES" class="bordered-badge">
              <span class="fw-normal dm-fs-0-9-rem d-flex flex-wrap gap-1 justify-content-end me-2">
                <span v-for="cs in $_.get(dataRecord.project, 'buyer_categories', [])" class="ms-1 badge badge-light-primary">
                  {{ cs.name }}
                </span>
              </span>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <div class="">
            <label for="buyer_categories" class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label mb-3">Buyer
              Categories</label>
            <div class="d-flex align-items-center position-relative my-1">
              <span class="svg-icon svg-icon-1 position-absolute ms-6"><i class="fa fa-plus-circle"></i></span>
              <input id="buyer_categories" @keydown.enter="addBuyerCategory" type="text"
                     placeholder="Type and press ENTER" class="form-control form-control-sm form-control-solid ps-14"/>
            </div>
            <has-error :form="post" field="project.buyer_categories"></has-error>
            <div>
              <draggable tag="div" :list="buyer_categories" handle=".handle" @end="reorderedBuyerCategory">
                <div v-for="(c, i) in buyer_categories" class="bg-gray-200 p-2 mb-1">
                  <span class=""><i class="fa fa-align-justify handle"></i></span>
                  <span>
                    {{ c }}
                  </span>
                  <span class="ms-3 cursor-pointer" @click="removeCategory('buyer_categories', i)"><i
                      class="fa fa-trash text-danger"></i></span>
                </div>
              </draggable>
            </div>
          </div>
          </div>
        </div>

        <div ref="field_buyer_ranks">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Buyer Ranks</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES" class="bordered-badge">
              <span class="fw-normal dm-fs-0-9-rem d-flex flex-wrap gap-1 justify-content-end me-2">
                <span v-for="cs in $_.get(dataRecord.project, 'buyer_ranks', [])" class="ms-1 badge badge-light-primary">
                  {{ cs.name }}
                </span>
              </span>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <div class="">
            <label for="buyer_ranks" class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label mb-3">Buyer
              Ranks</label>
            <div class="d-flex align-items-center position-relative my-1">
              <span class="svg-icon svg-icon-1 position-absolute ms-6"><i class="fa fa-plus-circle"></i></span>
              <input id="buyer_ranks" @keydown.enter="addBuyerRank" type="text"
                     placeholder="Type and press ENTER" class="form-control form-control-sm form-control-solid ps-14"/>
            </div>
            <has-error :form="post" field="project.buyer_ranks"></has-error>
            <div>
              <draggable tag="div" :list="buyer_ranks" handle=".handle" @end="reorderedBuyerCategory">
                <div v-for="(c, i) in buyer_ranks" class="bg-gray-200 p-2 mb-1">
                  <span class=""><i class="fa fa-align-justify handle"></i></span>
                  <span>
                    {{ c }}
                  </span>
                  <span class="ms-3 cursor-pointer" @click="removeCategory('buyer_ranks', i)"><i
                      class="fa fa-trash text-danger"></i></span>
                </div>
              </draggable>
            </div>
          </div>
          </div>
        </div>

        <div ref="field_project_status">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Project Status</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  placement="top"
                  type="select"
                  :update="projectUpdate"
                  name="status"
                  :value="dataRecord.project.status"
                  :context="dataRecord.project"
                  :options="drdata.project_statuses"
                  :config="{id: 'id', label: 'title', clearable: false, searchable: false}">
                <template #label>
                  <span class="bg-transparent me-auto">
                    {{
                      $_.get($_.first($_.filter(drdata.project_statuses, (ps) => (ps.id == dataRecord.project.status))), 'title')
                    }}
                  </span>
                </template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-select2
                name="project.status"
                label="Status"
                :form="post"
                v-model="post.project.status"
                :options="drdata.project_statuses"
                :config="{
                      label: 'title',
                      searchable: false,
                      clearable: false,
                    }"
                :classes="['form-select-solid form-select-sm']"
            />
          </div>
        </div>

        <div ref="field_engagement_date">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Engagement Date</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input type="date" :update="projectUpdate"
                              name="engagement_date"
                              :value="dataRecord.project.engagement_date"
                              placement="top"
                              :calendar-placement="['left']"
                              :context="dataRecord.project"
                              label="n">
                <template #label>
                  <span class="fw-normal dm-fs-0-9-rem d-flex flex-wrap gap-1 justify-content-end">
                    {{momentMixin(dataRecord.project.engagement_date) }}
                  </span>
                </template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <label for="project.engagement_date" class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label">Engagement Date</label>
            <date-picker id="project.engagement_date" v-model="post.project.engagement_date"
                         :typeable="false"
                         input-class="form-control form-control-sm form-control-solid mb-3"
                         format="DD-MM-YYYY"/>
            <has-error :form="post" field="project.engagement_date"></has-error>
          </div>
        </div>

        <div ref="field_close_date">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Estimated Completion Date</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input type="date" :update="projectUpdate"
                              name="close_date"
                              :value="dataRecord.project.close_date"
                              placement="top"
                              :calendar-placement="['left']"
                              :context="dataRecord.project"
                              label="n">
                <template #label>
                  <span class="fw-normal dm-fs-0-9-rem d-flex flex-wrap gap-1 justify-content-end">
                    {{momentMixin(dataRecord.project.close_date) }}
                  </span>
                </template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <label for="project.close_date" class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label">Estimated Completion Date</label>
            <date-picker id="project.close_date" v-model="post.project.close_date"
                         :typeable="false"
                         input-class="form-control form-control-sm form-control-solid mb-3"
                         format="DD-MM-YYYY"/>
            <has-error :form="post" field="project.close_date"></has-error>
          </div>
        </div>

        <div ref="field_estimated_fee">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Estimated Fee</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input
                  :update="projectUpdate"
                  name="value"
                  :value="dataRecord.project.value"
                  :context="dataRecord.project">
                <template #label>{{ numberFormat(dataRecord.project.value) }}</template>
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-input
              v-model="post.project.value"
              :form="post"
              name="project.value"
              label="Estimated Fee"/>
          </div>
        </div>

        <div ref="field_project_note">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Note</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              NOT APPLICABLE
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-input :required="false"
                        type="textarea"
                        v-model="post.project.note" :form="post"
                        name="project.note" label="Note"/>
          </div>
        </div>

        <div ref="field_hide_company_name">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Hide Company Name</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input :update="projectUpdate" name="hide_company_name"
                type="check"
                :context="dataRecord.project"
                :value="dataRecord.project.hide_company_name">
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-switch
                name="project.hide_company_name"
                label="Hide Company Name"
                :form="post"
                v-model="post.project.hide_company_name"
            />
          </div>
        </div>

        <div ref="field_hide_buyer_tracker">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
            <div :class="DATA_INPUT_LABEL_CLASSES"><label>Hide Buyer Tracker</label></div>
            <div :class="DATA_INPUT_VALUE_COL_CLASSES">
              <editable-input :update="projectUpdate" name="hide_buyer_tracker"
                type="check"
                :context="dataRecord.project"
                :value="dataRecord.project.hide_buyer_tracker">
              </editable-input>
            </div>
          </div>
          <div v-else-if="form_type == 'create'">
            <form-switch
                name="project.hide_buyer_tracker"
                label="Hide Buyer Tracker"
                :form="post"
                v-model="post.project.hide_buyer_tracker"
            />
          </div>
        </div>

        <!--opportunity-->
        <div ref="field_opportunity_title">
          <form-input :required="false"
                      v-model="post.opportunity.title" :form="post"
                      name="opportunity.title" label="Deal Title"/>
        </div>
        <div ref="field_pipeline">
          <form-select2
              :required="false"
              name="opportunity.pipeline"
              label="Pipeline"
              :form="post"
              @change="onChangePiplineStage($event)"
              v-model="post.opportunity.pipeline"
              :options="pipelines"
              :config="{
                id: 'id',
                label: 'name',
                searchable: false,
                clearable: false,
              }"
              :classes="['form-select-solid']"
          />
        </div>
        <div ref="field_pipeline_stage">
          <form-select2
              :required="false"
              name="opportunity.pipeline_stage"
              label="Pipeline stage"
              :form="post"
              v-model="post.opportunity.pipeline_stage"
              :options="pipeline_stages"
              :config="search_conf_pstage"
              :classes="['form-select-solid form-select-sm']"
          />
        </div>
        <div ref="field_lead_type">
          <form-select2
              :required="false"
              name="opportunity.lead_types"
              label="Lead types"
              :form="post"
              v-model="post.opportunity.lead_type"
              :options="lead_types"
              :config="{
          id: 'id',
          label: 'title',
          searchable: false,
          clearable: false,
        }"
              :classes="['form-select-solid']"
          />
        </div>
        <div ref="field_pitch_date">
          <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label">
            <slot name="labelText">Pitch Date</slot>
          </label>
          <date-picker v-model="post.opportunity.pitch_date"
                       input-class="form-control form-control-sm form-control-solid"/>
          <has-error :form="post" field="opportunity.pitch_date"></has-error>
        </div>
        <div ref="field_expected_exit_date">
          <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label">
            <slot name="labelText">Expected Exit Date</slot>
          </label>
          <date-picker v-model="post.opportunity.expected_exit_date"
                       input-class="form-control form-control-sm form-control-solid"/>
          <has-error :form="post" field="opportunity.expected_exit_date"></has-error>
        </div>
        <div ref="field_internal_introducers">
          <form-select2
              :required="false"
              name="opportunity.internal_introducers"
              label="Introducers"
              placeholder=""
              :form="post"
              :template="userTemplate"
              :selection-template="userSelectionTemplate"
              v-model="post.opportunity.internal_introducers"
              :options="users"
              :config="{
                    id: 'id',
                    label: 'name',
                    multiple: true,
                    ajax: {
                      paginated: true,
                      url: genUrl('users', null,  'search'),
                      term: 'query',
                    }
                  }"
              :classes="['form-select-solid']"
          >
          </form-select2>
        </div>
        <div ref="field_team_members">
          <form-select2
              :required="false"
              name="opportunity.team_members"
              label="Team Members"
              placeholder=""
              :form="post"
              :template="userTemplate"
              :selection-template="userSelectionTemplate"
              v-model="post.opportunity.team_members"
              :options="users"
              :config="{
                    id: 'id',
                    label: 'name',
                    multiple: true,
                    ajax: {
                      paginated: true,
                      url: genUrl('users', null,  'search'),
                      term: 'query',
                    }
                  }"
              :classes="['form-select-solid']"
          >
          </form-select2>
        </div>
        <div ref="field_owner">
          <form-select2
              :required="false"
              name="opportunity.owner"
              label="Owner"
              placeholder="Select One"
              :form="post"
              :template="userTemplate"
              :selection-template="userSelectionTemplate"
              v-model="post.opportunity.owner"
              :options="users"
              :config="{
                    id: 'id',
                    label: 'name',
                    multiple: false,
                    ajax: {
                      paginated: true,
                      url: genUrl('users', null,  'search'),
                      term: 'query',
                    }
                  }"
              :classes="['form-select-solid']"
          >
          </form-select2>
        </div>

        <div ref="field_opportunity_status">
          <form-select2
              :required="false"
              name="opportunity.opportunity_status"
              label="Opportunity Status"
              :form="post"
              v-model="post.opportunity.opportunity_status"
              :options="status"
              :config="{
                  id: 'id',
                  label: 'title',
                  searchable: false,
                  clearable: false,
                }"
              :classes="['form-select-solid']"
          />
        </div>

        <div ref="field_opportunity_followers">
          <form-select2
              :required="false"
              name="opportunity.followers"
              label="Followers"
              :form="post"
              v-model="post.opportunity.followers"
              :options="followers_opportunity"
              :config="search_conf_team_user"
              :classes="['form-select-solid']"
          >
          </form-select2>
        </div>
        <div ref="field_opportunity_note">
          <form-input :required="false"
                      type="textarea"
                      v-model="post.opportunity.note" :form="post"
                      name="opportunity.note" label="Note"/>
        </div>

        <div ref="field_logo_fetcher">
          <div v-if="form_type == 'data'" :class="DATA_INPUT_WRAPPER_CLASSES">
          </div>
          <div v-else-if="form_type == 'create'">
            <div v-show="!companyLocked">
              <h4 class="py-2 mt-10 dm-fs-1-1-rem dm-color-5e6278">Select Preferred Logo</h4>
              <div class="row mb-4">
                <div v-for="(logor, index) in logo_results" class="col-lg-4">
                  <!--begin::Card-->
                  <div
                      @click="selectLogo(index)"
                      class="dropzone dropzone_logo card h-100 flex-center bg-light-primary p-4"
                      :class="[logor.selected ? 'border-danger border border-dashed' : '']"
                  >
                    <div class="logo-container">
                      <img v-if="logor.has" :src="logor.blob_url" alt="" width="148px">
                    </div>
                  </div>
                  <!--end::Card-->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--Custom fields-->
        <div v-for="field in custom_fields">
          <div :ref="`field_${field.field}`">
            <div v-if="form_type == 'data'" class="row lightblue-hover-custom-form py-2">
              <div :class="DATA_INPUT_LABEL_CLASSES">{{field.title}}
                <span v-if="$_.get(field.custom,'field_description')" class="cursor-pointer" v-tooltip:top="`${$_.get(field.custom,'field_description')}`">
                  <img :src="static('/metronic/assets/media/svg/icons/General/Info.svg')" width="12px">
                </span>
              </div>
              <div :class="DATA_INPUT_VALUE_COL_CLASSES">
                <custom-data-display
                    @keydown.enter.stop="()=>{}"
                    :updater="customDataUpdate"
                    :context="customDataContext(field)"
                    :field="customDataField(field)"
                    :data="customData(field)"/>
              </div>
            </div>
            <div v-else-if="form_type == 'create'">
              <div v-if="field.custom.field_type==='text'">
                <form-input :required="false" v-model="post[field.field]" :form="post"
                            :name="field.field" :label="field.title"/>
              </div>
              <div v-else-if="field.custom.field_type==='decimal_2'">
                <form-input :required="false" v-model="post[field.field]" :form="post"
                            :name="field.field" :label="field.title"/>
              </div>
              <div v-else-if="field.custom.field_type==='long_text'">
                <form-input :required="false" v-model="post[field.field]" :form="post"
                            type="textarea"
                            :name="field.field" :label="field.title"/>
              </div>
              <div v-else-if="field.custom.field_type==='multiple_option'">
                <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label">
                  {{ field.title }}
                </label>
                <template v-if="field.custom.option_source_type">
                  <!--   TODO: custom field as options ref-->
                  <template v-if="field.custom.option_source==='company'">
                    <select2
                      v-model="post[field.field]"
                      :options="empty_array"
                      :config="{
                            multiple: true,
                            id: 'id',
                            label: 'name',
                            ajax: {
                              paginated: false,
                              url: genUrl('companies', null,  'search'),
                              term: 'name',
                            }
                          }"
                      />
                  </template>
                  <template v-else-if="field.custom.option_source==='pe_vc'">
                    <select2
                      v-model="post[field.field]"
                      :options="empty_array"
                      :config="{
                            multiple: true,
                            id: 'id',
                            label: 'name',
                            ajax: {
                              paginated: false,
                              url: genUrl('companies', null,  'search'),
                              term: 'name',
                              params: {pe_only: 1},
                            }
                          }"
                      />
                  </template>
                  <template v-else-if="field.custom.option_source==='contact'">
                    <select2
                      v-model="post[field.field]"
                      :options="empty_array"
                      :config="{
                            multiple: true,
                            id: 'id',
                            label: 'name',
                            ajax: {
                              paginated: false,
                              url: genUrl('contact', null,  'search'),
                              term: 'query',
                            }
                          }"
                      />
                  </template>
                  <template v-else-if="field.custom.option_source==='sector'">
                    <select2
                      v-model="post[field.field]"
                      :options="drdata.sectors"
                      :config="{
                            multiple: true,
                            id: 'id',
                            label: 'title',
                            ajax: {
                              paginated: true,
                              url: genUrl('sector'),
                              term: 'query',
                            }
                          }"
                      />
                  </template>
                  <template v-else-if="field.custom.option_source==='sub_sector'">
                    <select2
                      v-model="post[field.field]"
                      :options="drdata.sub_sectors"
                      :config="{
                            multiple: true,
                            id: 'id',
                            label: 'title',
                            ajax: {
                              paginated: true,
                              url: genUrl('sub_sectors'),
                              term: 'query',
                            }
                          }"
                      />
                  </template>
                  <template v-else-if="field.custom.option_source==='country'">
                    <select2
                      v-model="post[field.field]"
                      :options="drdata.country_codes"
                      :config="{
                            multiple: true,
                            id: 'code',
                            label: 'name',
                          }"
                      />
                  </template>
                  <template v-else-if="field.custom.option_source==='user'">
                    <select2
                      v-model="post[field.field]"
                      :options="empty_array"
                      :config="{
                        multiple: true,
                        id: 'id',
                        label: 'name',
                        ajax: {
                          paginated: true,
                          url: genUrl('users', null,  'search'),
                          term: 'query',
                        }
                      }"
                      />
                  </template>
                </template>
                <template v-else>
                  <select2
                    :required="false"
                    v-model="post[field.field]"
                    :options="field.custom.options"
                    :config="{
                                label: 'label',
                                multiple: true,
                              }"
                />
                </template>
              </div>
              <div v-else-if="field.custom.field_type==='single_option'">
                <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label">
                  {{ field.title }}
                </label>
                <template v-if="field.custom.option_source_type">
                <!--   TODO: custom field as options ref-->
                  <template v-if="field.custom.option_source==='company'">
                    <select2
                      v-model="post[field.field]"
                      :options="empty_array"
                      :config="{
                            id: 'id',
                            label: 'name',
                            ajax: {
                              paginated: false,
                              url: genUrl('companies', null,  'search'),
                              term: 'name',
                            }
                          }"
                      />
                  </template>
                  <template v-else-if="field.custom.option_source==='pe_vc'">
                    <select2
                      v-model="post[field.field]"
                      :options="empty_array"
                      :config="{
                            id: 'id',
                            label: 'name',
                            ajax: {
                              paginated: false,
                              url: genUrl('companies', null,  'search'),
                              term: 'name',
                              params: {pe_only: 1},
                            }
                          }"
                      />
                  </template>
                  <template v-else-if="field.custom.option_source==='contact'">
                    <select2
                      v-model="post[field.field]"
                      :options="empty_array"
                      :config="{
                            id: 'id',
                            label: 'name',
                            ajax: {
                              paginated: false,
                              url: genUrl('contact', null,  'search'),
                              term: 'query',
                            }
                          }"
                      />
                  </template>
                  <template v-else-if="field.custom.option_source==='sector'">
                    <select2
                      v-model="post[field.field]"
                      :options="drdata.sectors"
                      :config="{
                            id: 'id',
                            label: 'title',
                            ajax: {
                              paginated: true,
                              url: genUrl('sector'),
                              term: 'query',
                            }
                          }"
                      />
                  </template>
                  <template v-else-if="field.custom.option_source==='sub_sector'">
                    <select2
                      v-model="post[field.field]"
                      :options="drdata.sub_sectors"
                      :config="{
                            id: 'id',
                            label: 'title',
                            ajax: {
                              paginated: true,
                              url: genUrl('sub_sectors'),
                              term: 'query',
                            }
                          }"
                      />
                  </template>
                  <template v-else-if="field.custom.option_source==='country'">
                    <select2
                      v-model="post[field.field]"
                      :options="drdata.country_codes"
                      :config="{
                            id: 'code',
                            label: 'name',
                          }"
                      />
                  </template>
                  <template v-else-if="field.custom.option_source==='user'">
                    <select2
                      v-model="post[field.field]"
                      :options="empty_array"
                      :config="{
                            id: 'id',
                            label: 'name',
                            ajax: {
                              paginated: true,
                              url: genUrl('users', null,  'search'),
                              term: 'query',
                            }
                          }"
                      />
                  </template>
                </template>
                <template v-else>
                  <select2
                      :required="false"
                      v-model="post[field.field]"
                      :options="field.custom.options"
                      :config="{
                                  label: 'label'
                                }"
                  />
                </template>
              </div>
              <div v-else-if="field.custom.field_type==='date'">
                <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label d-flex">
                  {{ field.title }}
                  <!--{{field.rKey}} {{post[field.field]}} {{post.data()[field.field]}}-->
                </label>
                <date-picker
                            :value="post[field.field]"
                            @input="(val) => setDateForce(field.field, val)"
                           :typeable="false"
                             input-class="form-control form-control-sm form-control-solid mb-3 w-100"
                            value-type="format"
                             format="YYYY-MM-DD"/>
              </div>
              <has-error :form="post" :field="field.field"></has-error>
            </div>
          </div>
        </div>
      </div>

      <div ref="fields_rend" :class="{'px-2': form_type == 'data'}">
        <div v-for="section in sections">
          <h4 v-show="section.section.title_show" class="mb-4" :class="{'ms-2': form_type == 'data'}">{{ section.section.title }}</h4>
          <div class="row" v-for="row in section.rows">
            <div v-for="(field, colIndex) in row.fields" :class="`col col-md-${field.width} div-strip`" :style="[rendColStyle]">
              <div :ref="`rend_field_${field.field}`"></div>
            </div>
          </div>
        </div>
      </div>

    </template>
    <template #footer-section><div v-if="form_type == 'data'"></div></template>
  </modal-form-helper>
</template>

<script>
import cm from "@mxn/create"
import handle_custom_fields_render from './handle_custom_fields_render'
import UserSelector from "@cc/includes/UserSelector.vue";
import CustomDataDisplay from "@cc/modules/crm/opportunities/CustomDataDisplay.vue";

export default {
  components: {UserSelector, CustomDataDisplay},
  mixins: [cm, handle_custom_fields_render],
  props: {
    form_type: {
      default: 'create', //create|data
    },
    resource_id: null,
    form: null,
    source: '',
    url_key: {
      default: 'form_data_save'
    },
    company: {default: null},
    project: {default: null},
    asModal: {default: true},
    // customFields: {default: []},
    attach_buyer_project_id: {default: null},
    navigate_to_created: {default: true},
  },
  data() {
    return {
      form_category: 'opp_biz',
      id: null,
      isModal: true,

      searchingName: false,
      nameDuplicates: [],

      empty_array: [],

      project_stages: [],
      contact_offices: [],
      // project_statuses: [],
      introducers: [],
      pteam_members: [],
      buyer_categories: [],
      buyer_ranks: [],
      companies_wf: [],
      drdata: {
        companies: [],
        titles: [],
        ownerships: [],
        contacts: [],
        company_type: [],
        sectors: [],
        sub_sectors: [],
        sources: [],
        trading_status: [],
        ownership: [],
        relationship: [],
        corporate_status: [],
        currency: [],
        country_codes: [],
        transaction_types: [],
        project_statuses: [],
        users: [],
      },
      pe_companies: [],
      followers_opportunity: [],
      followers_company: [],
      tags:[],
      // fields: this.customFields,
      first_name_opts: [],
      pipelines: [],
      pipeline_stages: [],
      lead_types: [],
      users: [this.$user],
      post: Form.make({
        form: null,
        company_id: null,
        contact_id: null,
        address_id: null,
        contact: {
          title: null,
          first_name: '',
          last_name: '',
          office: null,
          linkedin_url: '',
          direct_mobile: '',
          direct_phone: '',
          job_title: '',
          email: '',
          tracker: false,
          users: [this.$user.id],
          tags:[],
        },
        company: {
          name: '',
          business_description: '',
          acquisition_strategy: '',
          // ownership: null,
          country: null,
          ebitda: '',
          revenue: '',
          pe_companies: [],
          linkedin_url: '',
          created_by_entry: null,
          followers: [],
        },
        company_detail: {
          source: '',
          employees: null,
          company_type: null,
          sectors: [],
          sub_sectors: [],
          company_house_no: '',
          website: '',
          main_shareholders: '',
          min_investment_size: null,
          max_investment_size: null,
          current_fund_size: null,
          left_to_deploy: null,
        },
        address: {
          branch: '',
          street_line_one: '',
          street_line_two: '',
          city: '',
          state: '',
          postcode: '',
          // country: '',
        },
        project: {
          name: '',
          status: null,
          project_type: null,
          project_stage: null,
          working_for: null,
          introducers: [],
          team_members: [],
          hide_company_name: false,
          hide_buyer_tracker: false,
          engagement_date: null,
          close_date: null,
          value: '',
          note: '',
        },
        opportunity: {
          title: null,
          pitch_date: null,
          expected_exit_date: null,
          pipeline: '',
          lead_type: '',
          pipeline_stage: '',
          internal_introducers: [],
          team_members: [],
          owner: this.$user.id,
          opportunity_status:'',
          followers: [],
          note: '',
        },
        attach_buyer_project_id: null,
      }),
      is_buyside: false,
      status:[],
      cnameResults: [],
      cnameLoading: false,

      lockKeycname: 'lc_key_cname',
      lockKeybname: 'lc_key_bname',
      lockKeyfname: 'lc_key_fname',

      companyLocked: false,
      contactLocked: null,
      addressLocked: null,

      logo_results: [{}, {}, {}],
      logo: {
        has: false,
        link: '',
        source: '',
        data: '',
        blob_url: '',
      },

      //existing record (data type forms)
      dataRecord: {
        project: {},
        company: {
          detail: {}
        },
      },
      custom_fields_data: {},
      DATA_INPUT_WRAPPER_CLASSES: 'row lightblue-hover-custom-form py-2',
      DATA_INPUT_LABEL_CLASSES: 'col-6 fs-7',
      DATA_INPUT_VALUE_COL_CLASSES: 'col-md-6 text-end fs-15px custom-form-data-col',
    };
  },
  computed: {
    rendColStyle(){
      return {
        'min-height': '36px',
      }
    },
    cnameBaseClasses(){
      return ''
      return this.companyLocked ? 'input-value-locked' : ''
    },
    fnameBaseClasses(){
      return ''
      return this.contactLocked ? 'input-value-locked' : ''
    },
    branchBaseClasses(){
      return ''
      return this.addressLocked ? 'input-value-locked' : ''
    },
    search_conf_team_user(){
      return {
        id: 'identifier',
        label: 'name',
        multiple: true,
        ajax: {
          paginated: false,
          url: this.genUrl('followers', null, 'team_user_search'),
          term: 'query',
        }
      }
    },
    pe_company_ajax_config(){
      return {
        multiple: true,
        id: 'id',
        label: 'name',
        ajax: {
          paginated: false,
          url: this.genUrl('companies', null,  'search'),
          term: 'name',
          params: {pe_only: 1},
        }
      }
    },
    contact_office_ajax_config(){
      return {
        id: 'id',
        label: 'branch',
        ajax: {
          paginated: false,
          url: this.genUrl('office_address'),
          term: 'query',
          params: {company: this.companyLocked},
        }
      }
    },
    search_conf_tags(){
      return {
        id: 'id',
        label: 'tag',
        multiple:true,
        ajax: {
          paginated: false,
          url: this.genUrl('contact_tags'),
          term: 'query',
          params: {tag_type: 'opportunity'},
          multiple:true,
        }
      }
    },
    first_name_ajax_config() {
      return {
        id: 'first_name',
        label: 'name',
        raw: {
          tags: true
        },
        ajax: {
          paginated: false,
          url: this.genUrl('contact', null, 'search'),
          term: 'query',
          params: {company: this.post.company},
        }
      }
    },
    search_conf_company() {
      return {
        id: 'id',
        label: 'name',
        ajax: {
          paginated: false,
          url: this.genUrl('companies', null, 'search'),
          term: 'name',
        }
      }
    },
    search_conf_pstage() {
      return {
        id: 'id',
        label: 'name',
        // ajax: {
        //   paginated: false,
        //   url: this.genUrl('pipeline_stages'),
        //   term: 'name',
        //   params: {pipeline: this.post.opportunity.pipeline}
        // }
      }
    },
    optgroupSubsectors() {
      const selectedSectors = this.form_type == 'data' ? this.dataRecord.company.detail.sectors : this.post.company_detail.sectors
      if (!selectedSectors) return []

      let data = []
      this.drdata.sectors.filter(sec => selectedSectors.map(String).includes(String(sec.id))).forEach(sec => {
        data.push({
          id: sec.id,
          text: sec.title,
          children: this.drdata.sub_sectors.filter(sc => sec.id == sc.sector).map(sc => ({id: sc.id, text: sc.title}))
        })
      })

      return data
    },
    isBuyside(){
      return this.drdata.transaction_types.some(tx => {
        return tx.is_buyside && (tx.id == this.post.project.project_type || tx.id == this.dataRecord.project.project_type);
      });
      console.log('BUYSIDE_CALC', is_buyside_match_found);
      this.is_buyside = is_buyside_match_found;
    },
  },
  watch: {
    // 'post.project.project_type': {
    //   handler(val, oldVal){
    //     this.calcBuyside()
    //   },
    //   deep: true
    // },
  },
  created() {
    this.searchCnameDebounced = _.debounce(() => this.searchName(), this.SEARCH_DEBOUNCE_MS)
  },
  mounted() {
    if(this.company?.id){
      this.cnameHandleSubmit(this.company)
    }

    this.fetchCompanyHelpers()

    axios.get(this.genUrl('form_settings', null, 'get_form_data'))
        .then(({data}) => {
            console.log(data)
            this.pipelines = data.pipelines;
            this.lead_types = data.lead_types;
            let default_pipelines = (data.pipelines).find((el) => (el.name.toLowerCase()).trim() == "origination team - prospecting")

            if(default_pipelines){
              this.post.pipeline = default_pipelines?default_pipelines.id:''
              this.getPipelinesStages(default_pipelines.id)
            }

        })

    let url = this.genUrl('form_layout', null, 'fields')
    this.getCustomFields(url)
    // this.fetchRenderFields(url)
    this.fetchOpportunityStatus()
  },
  methods: {
    // checkAuthorizedUser(tag){
    //   axios.get(this.genUrl('contact_tags', tag, 'post'))
    //   .then(({data}) => {

    //     const exist = data?.users.some(
    //       user => user.id === this.$user.id
    //     )
    //     if(!exist){
    //       this.post.contact.tag = null
    //       this.toastWarning('Warning','You not not authorised to tag this individual. Please speak to [add members names] to add this person')
    //     }

    //   })
    //   .catch(err => console.error(err))
    // },
    async checkAuthorizedUser(tagId) {
      for (const id of tagId) {
        const { data } = await axios.get(
          this.genUrl('contact_tags', id, 'post')
        )

        const exist = data?.users?.some(
          user => user.id === this.$user.id
        )

        if (!exist) {
          this.post.contact.tag = []
          this.toastWarning(
            'Warning',
            'You are not authorised to use one or more selected tags. Please speak to the tag owner.'
          )
          return false
        }
      }

      return true
    },
    projectUpdate: async function (name, value, context) {
      console.log('projectUpdate', [name, value, context])
      let val_ = value
      switch (name) {
        case 'close_date':
          val_ = this.momentMixin(value, 'YYYY-MM-DD') || null
          break
        default:
          break
      }

      let post = {}
      post[name] = val_
      await this.$axios.patch(this.genUrl('projects', this.resource_id), post)
          .then(({data}) => {
            this.toastSuccess()
            this.postRenderFields()
          })
          .catch(err => console.error(err))
    },
    companyBaseUpdate: async function (name, value, context) {
      console.log('companyBaseUpdate', [name, value, context])
      let val_ = value

      let post = {}
      post[name] = val_
      await this.$axios.patch(this.genUrl('companies', this.dataRecord.company.id), post)
          .then(({data}) => {
            this.toastSuccess()
            this.postRenderFields()
          })
          .catch(err => console.error(err))
    },
    companyDetailUpdate: async function (name, value, context) {
      console.log('companyDetailUpdate', [name, value, context])
      let val_ = value

      let post = {}
      post[name] = val_
      await this.$axios.patch(this.genUrl('company_details', this.dataRecord.company.detail.id), post)
          .then(({data}) => {
            this.toastSuccess()
            this.postRenderFields()
          })
          .catch(err => console.error(err))
    },
    postRenderFields(){
      if(this.form_type == 'create'){
        this.post.update({
          ...this.post,
          // to add this company (in case a company Form), add this as buyer to the given project.
          attach_buyer_project_id: this.attach_buyer_project_id
        })
      }

      if(this.form_type != 'data'){
        return
      }
      // const resource = this.formLayout.resource
      axios.get(this.genUrl('form_data_instance'), {params: {form_id: this.form.id, resource_id: this.resource_id}})
                .then(({data}) => {
                    this.dataRecord = data
                    if(this.form?.resource == 'project'){
                      this.custom_fields_data = {...data.project.custom_data, ...data.company.custom_data}
                      this.companies_wf = this.dataRecord.project.working_for ? [this.dataRecord.project.working_for] : []
                      this.pe_companies = this.dataRecord.company.pe_companies ? this.dataRecord.company.pe_companies : []
                      this.followers_company = this.dataRecord.company.followers ? this.dataRecord.company.followers : []
                    }
                    // const custom_fields_data = {...data.custom_data, ...data.company.custom_data}
                    // for (let key in custom_fields_data) {
                    //     if (this.post.data().hasOwnProperty(key)) {
                    //       console.log('keyhas', key, custom_fields_data[key]);
                    //       this.post.update({
                    //         ...this.post,
                    //         [key]: custom_fields_data[key],
                    //       })
                    //     }
                    // }
                })
                .catch(err => console.error(err))
    },
    customDataUpdate: async function (name, value, context) {
      console.log('custom_data_update', [name, value, context])
      if(context.resource == 'project'){
        await this.projectUpdate(name, value, context)
        return
      }
      if(context.resource == 'company'){
        await this.companyBaseUpdate(name, value, context)
        return
      }
      console.error('customDataUpdate MISS')
    },
    customDataField(field){
      return {
        ...field,
        field_key: field.field,
        field_type: field.custom.field_type,
        option_source_type: field.custom.option_source_type,
        option_source: field.custom.option_source,
        option_source_custom: field.custom.option_source_custom,
        options: field.custom.options
      }
    },
    customData(field){
      // all custom data as obj (TODO: filter by form type and curent field resource?)
      // return this.post.data()
      if(this.form?.resource == 'project'){
        return this.custom_fields_data
      }
      return {}
    },
    customDataContext(field){
      return field
    },
    // project
    // calcBuyside(){
    //   const is_buyside_match_found = this.drdata.transaction_types.some(tx => {
    //     return tx.is_buyside && tx.id == this.post.project.project_type;
    //   });
    //   console.log('BUYSIDE_CALC', is_buyside_match_found);
    //   this.is_buyside = is_buyside_match_found;
    // },
    onTrxChange(type_id) {
      this.post.project.project_stage = null
      axios.get(this.genUrl('projects', null, 'get_project_stages'), {
        params: {
          id: type_id
        }
      })
          .then(({data}) => {
            this.project_stages = data.data
          })
          .catch(err => console.error(err))
    },
    removeCategory(type, i) {
      this[type].splice(i, 1)
    },
    addBuyerCategory(e) {
      this.addCategory('buyer_categories', e)
    },
    addBuyerRank(e) {
      this.addCategory('buyer_ranks', e)
    },
    addCategory(type, e) {
      e.preventDefault()
      const val = e.target.value
      if (!val.length) return this.toastWarning('Type a name')

      const found = this[type].find(e => e === val)
      if (found) return this.toastWarning('Item exists')

      this[type].push(val)
      e.target.value = ''
    },
    reorderedBuyerCategory(list) {
    },
    // logo picker
    removeLogos(){
      this.logo_results = [{},{},{}]
    },
    selectLogo(index){
      //shuffle true/false
      this.logo_results[index].selected = !this.logo_results[index].selected
      console.warn(this.logo_results[index].selected)

      //set others to false
      this.logo_results.forEach((lg, idx) => {
        if(idx !== index){
          lg.selected = false
        }
      })
      console.warn(this.logo_results)
      this.$forceUpdate()
    },
    async getLogoBlob(cse_data, logoIndex) {

      const buildProxyUrl = (link) => {
        return `${this.genUrl('companies', null, 'company_logo_proxy')}?image_url=${link}`
      }

      const setLogoData = (logoData) => {
        this.logo_results[logoIndex].has = true
        this.logo_results[logoIndex].data = logoData
        this.logo_results[logoIndex].blob_url = URL.createObjectURL(this.logo_results[logoIndex].data);
        this.$forceUpdate()
      }

      try {
        // Fetch the image data
        const response = await axios.get(buildProxyUrl(cse_data.link), {responseType: 'blob'});
        setLogoData(response.data)

        return true
      } catch (error) {
        // this.removeLogo()
        console.error('GET_LOGO_ERROR', error);
        console.log('TRYING_FALLBACK_THUMBNAIL');

        try {
          const response = await axios.get(buildProxyUrl(cse_data.image.thumbnailLink), {responseType: 'blob'});
          setLogoData(response.data)

          return true
        } catch (error2) {
          // this.removeLogo()
          console.error('GET_LOGO_THUMB_FAILED_TOO', error);
        }
      }
    },
    async attachLogoBlob(company) {
      let logo = this.logo_results.find(lg => lg.selected)

      if (!logo?.has) {
        console.log("NO_LOGO_LINK")
        this.close()
        return
      }
      this.toastSuccess("Uploading logo..")

      try {
        // Create a FormData object and append the image Blob
        const formData = new FormData();
        formData.append('logo', logo.data, `${company.id}_${company.name}_logo_automated_csx.png`);

        const uploadResponse = await axios.put(this.genUrl('companies', company.id, 'logo'), formData);

        if (uploadResponse.status === 200) {
          this.toastSuccess("Logo uploaded!")
        } else {
          this.toastError("Failed to upload logo!")
        }
      } catch (error) {
        console.error('LOGO_UPLOAD_ERROR:', error);
      }

      this.close()
    },
    removeLogo() {
      this.logo = {
        has: false,
        link: '',
        source: '',
        data: '',
        blob_url: '',
      }
    },
    searchName(input) {
      this.companyLocked = false
      this.post.company.name = input

      this.contactLocked = false
      this.post.company.name = input

      this.addressLocked = false
      this.post.address.branch = input

      this.removeLogos()
      if (input.length > 2) {
        this.$axios.get(this.genUrl('companies', null, 'get_company_logo'), {
          params: {name: input}
        }).then(({data}) => {
          if (!data.data) return

          data.data.forEach((gcd, idx) => {
            this.getLogoBlob(gcd, idx)
          })
        })
        .catch(err => {
          // this.removeLogos()
          this.toastLaraValidation(err)
        })
      }

      return new Promise((resolve, reject) => {
        if (input.length < 2) {
          return resolve([])
        }
        axios.get(this.genUrl('companies', null, 'search'), {
          params: {name: input}
        })
            .then(({data}) => {
              resolve(data.data)
            })
            .catch(err => reject(err))
      })
    },
    searchFname(input) {
      this.contactLocked = false
      this.post.contact.first_name = input

      if(!this.companyLocked){
        return []
      }

      return new Promise((resolve, reject) => {
        if (input.length < 2) {
          return resolve([])
        }
        axios.get(this.genUrl('contact', null, 'search'), {
          params: {query: input, company: this.companyLocked}
        })
            .then(({data}) => {
              this.post.contact.last_name = ''
              resolve(data.data)
            })
            .catch(err => reject(err))
      })
    },
    searchBname(input) {
      this.addressLocked = false
      this.post.address.branch = input

      if(!this.companyLocked){
        return []
      }

      return new Promise((resolve, reject) => {
        if (input.length < 2) {
          return resolve([])
        }
        axios.get(this.genUrl('office_address'), {
          params: {query: input, company: this.companyLocked}
        })
            .then(({data}) => {
              resolve(data.data)
            })
            .catch(err => reject(err))
      })
    },
    getResultValue(result) {
      return result.name
    },
    getFnameResultValue(result) {
      return result.name
    },
    getBnameResultValue(result) {
      return result.branch
    },
    cnameHandleSubmit(result) {
      // debugger
      this.companyLocked = result.id
      this.post.company.name = result.name
      this.lockKeycname = _.random(true)
      // this.$nextTick(() => {
      //   try{
      //     this.$refs.firstNameAutoComplete.$refs.input.focus()
      //   }catch (e){
      //     console.error("CANT_FOCUS_AUTOCOMPLETE_XR")
      //   }
      // })
      console.log(result)
    },
    fnameHandleSubmit(result) {
      this.contactLocked = result.id
      // this.post.contact.first_name = result.name
      const fullName = result.name;
      const parts = fullName.trim().split(/\s+/);
      this.post.contact.first_name = parts[0];
      this.post.contact.last_name = parts.slice(1).join(" ");
      this.lockKeyfname = _.random(true)
      console.log(result)
    },
    branchHandleSubmit(result) {
      this.addressLocked = result.id
      this.post.address.branch = result.branch
      this.lockKeybname = _.random(true)
      console.log(result)
    },
    getUrl(){
      return this.genUrl(this.url_key)
    },
    fetchCompanyHelpers() {
      axios.get(this.genUrl('companies', null, 'data'))
          .then(({data}) => {
            this.drdata = {
              ...this.drdata,
              ...data,
            }
            if(this.form_type == 'data'){
              this.project_stages = [...this.drdata.project_stages]
            }
            // let default_ownership = (data.ownerships).find((el) => (el.name.toLowerCase()).trim() == "private")
            // let default_company_type = (data.company_types).find((el) => (el.title.toLowerCase()).trim() == "trade")
            //
            // this.post.details.ownership = default_ownership.id
            // this.post.details.company_type = default_company_type.id

            this.users = [{...this.drdata.user}]
            // this.preCreate_()
          })
          .catch(err => console.error(err))
    },
    onChangePiplineStage(event){
      this.post.opportunity.pipeline_stage = null
      this.getPipelinesStages(event)
    },
    getPipelinesStages(pipeline_id){
      axios.get(this.genUrl('pipeline_stages'),{params: {pipeline: pipeline_id}})
      .then( ({data}) => {
          console.log(data.data)
          this.pipeline_stages = data.data

          // let default_pipeline_stage = (data.data).find((el) => (el.name.toLowerCase()).trim() == "qualified")
          // if(this.post.opportunity.hasOwnProperty('pipeline_stage')){
          //   this.post.opportunity.pipeline_stage = default_pipeline_stage ? default_pipeline_stage.id : ''
          // }
      })
    },
    postCreate(data){
      if(this.source == 'quick_menu'){
        // this.close()
        // return
      }

      // this.toastSuccess("Record created!")

      // only new creations of company
      if(!this.companyLocked && data.company){
        this.attachLogoBlob({id: data.company, name: this.post.company.name})
      }

      if(data.opportunity){
        return this.navigate_to_created ? this.$router.push({name: 'crm_opportunity_details', params: {id: data.opportunity}}) : 3;
      }

      if(data.project){
        if(this.$isProperModule()){
          return this.navigate_to_created ? this.$router.push({name: 'project_details', params: {id: data.project}}) : 3;
        }else{
          const proute = this.$router.resolve({
            name: 'project_details',
            params: {id: data.project}
          });
          window.open(proute.href, '_blank');
          // return
        }
      }

      if(data.company){
        // common?
        this.$root.$emit("company_created_project", {id: data.company})
        return this.navigate_to_created ? this.$router.push({name: 'company_details', params: {module: this.$module, id: data.company}}) : 3;
      }

      this.close()
    },
    searchDebounced(input) {
      this.post.first_name = input

      return new Promise((resolve, reject) => {
        if (input.length < 2) {
          return resolve([])
        }
        axios.get(this.genUrl('contact', null, 'search'), {
          params: {query: input, company: this.post.company}
        })
            .then(({data}) => {
              resolve(data.data)
            })
            .catch(err => reject(err))
      })
    },
    extraData() {
      const data = this.post.data()
      return {
        ...data,
        form: this.form.id,
        company_id: this.companyLocked ? this.companyLocked : null,
        contact_id: this.contactLocked ? this.contactLocked : null,
        address_id: this.addressLocked ? this.addressLocked : null,
        project: {
          ...data.project,
          buyer_categories: this.buyer_categories.length ? this.buyer_categories : undefined,
          buyer_ranks: this.buyer_ranks.length ? this.buyer_ranks : undefined,
          engagement_date: this.momentMixin(this.post.project.engagement_date, 'YYYY-MM-DD'),
        },
        opportunity: {
          ...data.opportunity,
          pitch_date: this.momentMixin(this.post.opportunity.pitch_date, 'YYYY-MM-DD'),
          expected_exit_date: this.momentMixin(this.post.opportunity.expected_exit_date, 'YYYY-MM-DD'),
        }
      }
    },
    edit() {
      this.startCompLoading()
      axios.get(this.genUrl(this.url_key, this.id, 'post'))
          .then(({data}) => {
            const contact = data.contacts[0]
            console.log(contact)
            this.post.update({
              ...this.post,
              ...data,
              ...contact
            })
          })
          .catch(err => console.error(err))
          .finally(() => this.endCompLoading())
    },
    fetchOpportunityStatus(){
      axios.get(this.genUrl('opportunity_status', null, 'get'))
          .then(({data}) => {
            console.log(data)
            this.status = data.data

            // if(this.status.length && this.post.opportunity.hasOwnProperty('opportunity_status')){
            //   //default status active
            //   let default_status = (data.data).find((el) => (el.title.toLowerCase()).trim() == "active")
            //   this.post.opportunity_status = default_status ? default_status.id : ''
            // }
          })
          .catch(err => {
            this.toastLaraValidation(err)
          })
    }
  },
}
</script>

<style>
input.autocomplete-input {
  background-color: #FCFCFC !important;
  font-size: unset;
  background-image: unset;
  padding: 0.55rem 0.77rem;
  border-radius: 0.325rem;
}

.input-value-locked input.autocomplete-input{
  border: #0a6aa1 1px solid !important;
  background: #a4a3a3 !important;
}

.custom-form-data-col .edinput-label{
  display: inline-block !important;
  width: 100%;
}
.div-strip:nth-child(odd){
  background-color: rgba(245, 248, 250, 0.75);
}
</style>

<style scoped>
.cname_result_list_menu {
    width: var(--cname-input-width);
}

.menu-sub-dropdown {
  border-radius: .4rem;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-color: var(--c-base);
}

.cname_search_input.menu-dropdown{
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.lightblue-hover-custom-form {
  padding: 0.25rem 0.5rem;
  transition: background 0.2s ease, box-shadow 0.2s ease;
}

.lightblue-hover-custom-form:hover {
  background: #f3f7fd;
  /*box-shadow: inset 0 0 0 1px #d6e6fb;*/
}
</style>